document.addEventListener("DOMContentLoaded", function () {
    const tablist = document.querySelector(".size_guide_tabs");
    if (!tablist) return;

    const tabs = Array.from(tablist.querySelectorAll("[role=\"tab\"]"));
    const categories = document.querySelectorAll(".size_guide_category");
    if (!tabs.length || !categories.length) return;

    function getUrlParam(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }

    function setUrlParam(name, value) {
      const url = new URL(window.location);
      url.searchParams.set(name, value);
      history.replaceState(null, null, url.toString());
    }

    function showCategory(categoryId) {
      categories.forEach(category => {
        const isActive = category.id === categoryId;
        category.style.display = isActive ? "block" : "none";
        if (isActive) {
          category.removeAttribute("hidden");
        } else {
          category.setAttribute("hidden", "");
        }
      });

      tabs.forEach(button => {
        const isActive = button.dataset.target === categoryId;
        button.classList.toggle("active", isActive);
        // Tabs pattern
        button.setAttribute("aria-selected", isActive ? "true" : "false");
        button.setAttribute("tabindex", isActive ? "0" : "-1");
      });

      setUrlParam("category", categoryId);
    }

    function focusTabByIndex(index) {
      tabs.forEach((tab, tabIndex) => {
        tab.setAttribute("tabindex", tabIndex === index ? "0" : "-1");
      });
      tabs[index].focus();
    }

    function handleTabKeydown(event, currentIndex) {
      switch (event.key) {
        case "ArrowLeft":
          event.preventDefault();
          focusTabByIndex(currentIndex > 0 ? currentIndex - 1 : 0);
          break;
        case "ArrowRight":
          event.preventDefault();
          focusTabByIndex(currentIndex < tabs.length - 1 ? currentIndex + 1 : tabs.length - 1);
          break;
        case "Home":
          event.preventDefault();
          focusTabByIndex(0);
          break;
        case "End":
          event.preventDefault();
          focusTabByIndex(tabs.length - 1);
          break;
        case "Enter":
        case " ":
          event.preventDefault();
          showCategory(tabs[currentIndex].dataset.target);
          tabs[currentIndex].focus();
          break;
      }
    }

    tabs.forEach(button => {
      button.addEventListener("click", function () {
        showCategory(this.dataset.target);
      });

      button.addEventListener("keydown", function (event) {
        const currentIndex = tabs.indexOf(this);
        if (currentIndex === -1) return;
        handleTabKeydown(event, currentIndex);
      });
    });

    const initialCategory = getUrlParam("category") || categories[0]?.id;
    if (initialCategory) {
      showCategory(initialCategory);
    }
  });
  
